/*
*
* File JS per il template Archive Press
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardPress from 'components/card-press/card-press';
import cardMediaKit from 'components/card-mediakit/card-mediakit';
import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-press.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//